import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.classifyAll()
    this.scrollToBottom()

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) this.classifyRow(node)
        })
      })
      this.scrollToBottom()
    })
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  classifyAll() {
    this.element.querySelectorAll("[data-sender-id]").forEach((row) => this.classifyRow(row))
  }

  classifyRow(row) {
    if (!row.dataset || !row.dataset.senderId) return
    const viewerId = this.element.dataset.viewerId
    if (!viewerId) return
    if (String(viewerId) === String(row.dataset.senderId)) {
      this.alignMine(row)
    }
  }

  alignMine(row) {
    row.classList.remove("justify-start")
    row.classList.add("justify-end")

    row.querySelector("[data-avatar='other']")?.classList.add("hidden")
    row.querySelector("[data-avatar='mine']")?.classList.remove("hidden")

    const bubble = row.querySelector("[data-bubble]")
    if (bubble) {
      bubble.classList.remove("bg-slate-100", "text-slate-900", "rounded-bl-sm")
      bubble.classList.add("bg-primary", "text-white", "rounded-br-sm")
    }

    const timestamp = row.querySelector("[data-timestamp]")
    if (timestamp) {
      timestamp.classList.remove("text-slate-500")
      timestamp.classList.add("text-white/70")
    }
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
